import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { SHORT_DATE_FORMAT } from '../../constants';
import * as _ from '../../lodash';
import TimeSlotRadioButton from './TimeSlotRadioButton';

export default class TimeSlotRadioButtons extends Component {
  parseTimeSlots() {
    const { timeslots, availableDates, selectedDate } = this.props,
          day = moment(selectedDate).format(SHORT_DATE_FORMAT);

    if (!timeslots.length || !availableDates.includes(day)) return [];

    return timeslots.sort((x, y) => moment(y.start).isSameOrAfter(moment(x.start)) ? -1 : 1);
  }

  render() {
    const {
      isDisplayRange,
      isShowRemainingSpace,
      onItemClick,
      timeZone,
      locale,
      timeFormat,
      selectedTimeSlot,
      style,
      quantity,
      getAvailability,
      translation
    } = this.props;

    const slots = this.parseTimeSlots().map((timeslot) => {
      const availability = getAvailability(timeslot),
            availableTimeSlot = availability >= quantity;

      return (
        <li key={timeslot.id}>
          <TimeSlotRadioButton
            disabled={!(availableTimeSlot)}
            onClick={(event) => {
              onItemClick(timeslot, event);
            }}
            timeslot={timeslot}
            isDisplayRange={isDisplayRange}
            isShowRemainingSpace={isShowRemainingSpace}
            availableSpace={availability}
            timeZone={timeZone}
            timeFormat={timeFormat}
            quantity={quantity}
            selectedTimeSlot={selectedTimeSlot}
            style={style}
            translation={translation}
          />
        </li>
      );
    });

    return <ul>{slots}</ul>;
  }
}

TimeSlotRadioButtons.propTypes = {
  timeslots: PropTypes.array,
  timeZone: PropTypes.string,
  locale: PropTypes.string,
  isDisplayRange: PropTypes.bool,
  isShowRemainingSpace: PropTypes.bool,
  availableDates: PropTypes.array,
  timeFormat: PropTypes.string,
  selectedDate: PropTypes.any,
  onItemClick: PropTypes.func,
  quantity: PropTypes.string,
};